export default {
  //MuiFormLabel: {
    asterisk: {
      color: '#ED4740',
      fontWeight: 800,
      '&$error': {
        color: '#ED4740',
        fontWeight: 800,
      },
    }
  //}
};
